import React from 'react';
import { connect } from 'react-redux'
import { Select, Tree } from 'antd';
import { WikiActions, XWikiActions } from '../../redux';

const { TreeNode } = Tree;

class XWikiSelectPage extends React.Component {
  state = {
    treeData: [
      { title: 'NODE0', key: '0' },
      { title: 'NODE1', key: '1', isLeaf: true },
    ],
  };

  onLoadData = treeNode =>
    new Promise(resolve => {
      if (treeNode.props.children) {
        resolve();
        return;
      }
      // this.props.dispatch(WikiActions.loadNodePages(treeNode.props.dataRef.nodeId))
      // .then(response => {
      //   console.log("result", response);
      //   this.setState({sub:response});
      //   resolve();
      //   return;
      // })
    });

  renderTreeNodes = data =>
    data.filter(item => {
      return (this.props.settings && Array.isArray(this.props.settings.filters))
        ? this.props.settings.filters.filter(filter => item.id.startsWith(filter.id)).length == 0
        : true
    }).map(item => {
      if (item.children) {
        return (
          <TreeNode title={(item.name)?item.name:item.id} key={item.id} dataRef={item}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode title={(item.name)?item.name:item.id} key={item.id} dataRef={item} />;
    });

  onSelect = (selectedKeys, info) => {
    //console.log('selected', selectedKeys, info);
    if (this.props.onSelectedPage){
      this.props.onSelectedPage(info.node.props.dataRef)
    }
  };

  handleChange = (value) => {
    //console.log(`Selected: ${value}`);
    this.props.onSelectedWiki(value);
  };

  render() {
    const {wikis, nodes} = this.props;
    console.log(this);
    return <div>
      <Select
        size={1}
        defaultValue="xwiki"
        onChange={this.handleChange}
        style={{
          width: '100%',
        }}
        options={wikis.map((wiki, i) => {return {value: wiki.id, label: wiki.name}}
        )}        
      />
      <Tree  onSelect={this.onSelect}>{this.renderTreeNodes(this.props.nodes)}</Tree>
    </div>
    
  }
}

export default connect(
  (state, props) => {
    const {vset, xwiki} = state;
    const {lang, graph } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      graph: (graph)?graph: vset.graph,
      settings: vset.xwiki,
      wikis: (xwiki.wikis)?xwiki.wikis:[],
      nodes: (xwiki.nodes)?xwiki.nodes:[],
    })
  },
  dispatch => ({
    onSelectedWiki (wikiName) {
      return dispatch(XWikiActions.loadSpaces(wikiName));
    },
    onSelectedPage (page) {      
      //console.log(page);
      const hashCode = page.id.split('').reduce((a,b)=>{a=((a<<5)-a)+b.charCodeAt(0);return a&a},0);
      const selected = Object.assign({}, page, {pageId : hashCode});
      if (page.url)
        return Promise.all([dispatch(XWikiActions.SELECTED(page)), dispatch(WikiActions.SELECTED(selected))]);
      else
        return Promise.all([dispatch(XWikiActions.SELECTED(null)), dispatch(WikiActions.SELECTED(null))]);
    }    
  })
)(XWikiSelectPage)
